
import area from '../base/area'
import momenttime, { MOMENT_TIME } from '../../momenttime'
import format, { FORMAT } from '../core/format'
import paipan, { PAIPAN } from '../core/paipan'
import realsuntime, { REAL_SUN_TIME } from '../core/realsuntime'
import { UTILS } from '../../utils'

/**
 * 处理起盘页面相关逻辑数据
 */

var COLLATE_DATA_MANAGER = {
    /**
     * 生成出生地信息:根据地址选择器返回的array
     * @param {地址选择器返回的数组} arr 
     */
    getSelectedAreaStringByArr(arr) {
        // console.log('getSelectedAreaStringByArr-----', arr);
        var result = [], tempCode = 0, areaStr = '', posStr = '';
        for (var i = 0; i < arr.length; i++) {
            tempCode = arr[i]['code'];
            areaStr += (arr[i]['name'] + ' ');
        }
        posStr += ('东经' + area.latitude_list[tempCode] + '度 ');
        posStr += ('北纬' + area.longtude_list[tempCode] + '度');
        result.push(areaStr, posStr);
        return result;
    },
    /**
     * 生成出生地信息:根据数据里的location字段
     * @param {personData里的location字段} str 
     */
    getSelectedAreaStringByString(str) {
        if(!str || str == ''){
            return '';
        }
        var data = JSON.parse(str);
        var result = [], areaStr = '', posStr = '';
        // console.log('getSelectedAreaStringByString-----', str, data);
        areaStr += data.province + ' ';
        areaStr += data.city + ' ';
        areaStr += data.name;

        posStr += ('东经' + data.latitude + '度 ');
        posStr += ('北纬' + data.longtude + '度');
        result.push(areaStr, posStr);
        return result;
    },
    /**
     * 获取输入生日框的显示数据:根据日历输入返回的数据
     * @param {输入生日后的数据格式} data 
     * {year: '1988', month: '01', day: '29', hour: '22', minute: '00', isLunar: '', unknown: ''}
     */
    getSelectedBirthdayStringByData(data) {
        var result = [], tempdata = {}, str1 = '', str2 = '';
        var year = parseInt(data.year), month = parseInt(data.month), day = parseInt(data.day), hour = parseInt(data.hour), minute = parseInt(data.minute);
        var timeStr1 = data.unknownTime ? '' : '  ' + ((hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute));
        var timeStr2 = data.unknownTime ? '' : ' ' + FORMAT.getShiChenByNumber(hour);
        var isRun = data.run ? 1 : 0;

        if (data.isLunar) {
            // 农历时间
            tempdata = PAIPAN.Lunar2Solar(year, month, day, isRun);
            str1 = tempdata.y + '年' + (tempdata.m < 10 ? '0' + tempdata.m : tempdata.m) + '月' + (tempdata.d < 10 ? '0' + tempdata.d : tempdata.d) + '日' + timeStr1;
            str2 = FORMAT.getChineseWordByNumber('year', year) + (tempdata.r == 1 || isRun == 1 ? '闰' : '') + FORMAT.getChineseWordByNumber('month', month) + FORMAT.getChineseWordByNumber('day', day) + timeStr2;
        } else {
            // 公历时间
            tempdata = PAIPAN.Solar2Lunar(year, month, day);
            str1 = year + '年' + (month < 10 ? '0' + month : month) + '月' + (day < 10 ? '0' + day : day) + '日' + timeStr1;
            str2 = FORMAT.getChineseWordByNumber('year', tempdata.y) + (tempdata.r == 1 || isRun == 1 ? '闰' : '') + FORMAT.getChineseWordByNumber('month', tempdata.m) + FORMAT.getChineseWordByNumber('day', tempdata.d) + timeStr2;
        }
        result.push(str1);
        result.push(str2);
        console.log('getSelectedBirthdayStringByData----', result);
        return result;
    },
    /**
     * 获取输入生日框的显示数据:根据数据birthday字段
     * @param {未知时间字段} data 
     */
    getSelectedBirthdayStringByDetailData(data) {
        var starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var date = MOMENT_TIME.getTimeArrayByTimeStamp(starttime * 1000);
        var dateData = {year: date[0], month: date[1], day: date[2], hour: date[3], minute: date[4], isLunar: '', unknownTime: data.unknown}
        return this.getSelectedBirthdayStringByData(dateData);
    },
    // 获取排盘参数Location
    getPaiPanParamsLocation(params) {
        var result = {}, lctArr = params;
        result['province'] = lctArr[0].name;
        result['city'] = lctArr[1].name;
        result['name'] = lctArr[2].name;
        result['latitude'] = area.latitude_list[lctArr[2].code];
        result['longtude'] = area.longtude_list[lctArr[2].code];
        console.log('起盘出生地为::::', result);
        return JSON.stringify(result);
    },
    // 获取排盘参数Birthday
    getPaiPanParamsBirthday(params) {
        var y, m, d, h, mi, r;
        h = parseInt(params.hour);
        mi = parseInt(params.minute);
        y = parseInt(params.year);
        m = parseInt(params.month);
        d = parseInt(params.day);
        r = params.run ? 1 : 0;

        // 农历要转换成公历
        if (params.isLunar) {
            var temp = PAIPAN.Lunar2Solar(y, m, d, r)
            y = temp.y;
            m = temp.m;
            d = temp.d;
        }
        // 拼凑字符串
        var dateStr = UTILS.formatYearNum(y) + '-';
        dateStr = dateStr + ((m > 0 && m < 10) ? ('0' + m) : m) + '-';
        dateStr = dateStr + ((d > 0 && d < 10) ? ('0' + d) : d) + ' ';
        if (!params.unknownTime) {
            dateStr = dateStr + ((h >= 0 && h < 10) ? ('0' + h) : h) + ':';
            dateStr = dateStr + ((mi >= 0 && mi < 10) ? ('0' + mi) : mi) + ':00';
        }else{
            dateStr = dateStr + '00:00:00'
        }
        // var time = moment(dateStr).unix();
        var time = MOMENT_TIME.getUnixTimeByTimeStr(dateStr);

        console.log('起盘生日为::::', dateStr, time);
        return dateStr;
    },
    // 获取编辑页面表单数据:用户起盘信息personData // 简化处理一下
    getFormDataByPersonData(data) {
        return {
            'f_name': data.f_name, 
            'f_group': data.f_group,       
            'sex': data.sex,            
            'birthday': data.birthdayDate,  
            'location': data.location,
            'real_time': data.realDate,
            'unknown': data.unknown,
            'zwzs': data.zwzs 
        }
    },
    getInputDataByPersonData(data) {
        var starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var time = MOMENT_TIME.getTimeArrayByTimeStamp(starttime * 1000);
        return {
            "unknownTime": data.unknown,
            "isLunar": data.isLunar,
            "year": time[0], 
            "month": time[1], 
            "day": time[2], 
            "hour": time[3], 
            "minute": time[4]
        }
    },
    // 获取天干数据数组
    getTianGanListByCompData(compData) {
        var resultList = [];
        var index = compData.text ? FORMAT.getDiZhiIndexByText(compData.text) : -1;
        for(var i = 0; i < 10; i++){
            var textData = FORMAT.getTianGanWordDataByIndex(i);
            var selected = textData.text == compData.text ? true : false;
            var data = Object.assign({ selected: selected }, textData);
            if(index == -1){
                // 对比数据为空的情况
                resultList.push(data);
            }else{
                // 对比数据不为空，取同奇偶性
                if((i+index)%2 == 0){
                    resultList.push(data);
                }
            }
        }
        // console.log('getTianGanListByCompData-----', compData.text, resultList);
        return resultList;
    },
    // 获取地支数组数据
    getDiZhiListByCompData(compData, textData) {
        var resultList = [];
        var index = compData.text ? FORMAT.getTianGanIndexByText(compData.text) : -1;
        console.log('getDiZhiListByCompData-----', compData, textData);
        for(var i = 0; i < 12; i++){
            var newTextData = FORMAT.getDiZhiWordDataByIndex(i);
            var selected = newTextData.text == textData.text ? true : false;
            var data = Object.assign({ selected: selected }, newTextData);
            if(index == -1){
                // 对比数据为空的情况
                resultList.push(data);
            }else{
                // 对比数据不为空，取同奇偶性
                if((i+index)%2 == 0){
                    resultList.push(data);
                }
            }
        }
        // console.log('getDiZhiListByCompData-----', compData.text, resultList);
        return resultList;
    },
    // 获取当前地支在弹框八字里的索引
    checkTextDataIndexInEightWordArr(origiData, textData){
        for(var data of origiData){
            var index = origiData.indexOf(data);
            if(data.text == textData.text){
                return index;
            }
        }
        return -1;
    },
    /**
     * 检查是否是闰月
     * @param {年} year 
     * @param {月} month 
     */
    checkMonthIsRun(year, month) {
        var tempdata = PAIPAN.Lunar2Solar(year, month, 1, 1);
        return tempdata ? true : false;
    },
    // 获取今天的时间数据
    getTodayCalendarInfoData() {
        var today = MOMENT_TIME.getTimeArrayByTimeStamp(), resultData = {},
            year = today[0], month = UTILS.getTimeStrByInt(today[1]), day = UTILS.getTimeStrByInt(today[2]), 
            week = MOMENT_TIME.getTimeWeekDayByTimeStamp(),
            baziData = PAIPAN.GetInfo(0, MOMENT_TIME.getUnixTimeByTimeStr(), 1), 
            jie = '', jieBegTime = baziData.jieqi.beg.time, jieEndTime = baziData.jieqi.end.time;
        // 阳历日期+星期几
        resultData['solar'] = {y: year, m: month, d: day, week: UTILS.getWeekStrByInt(week)};
 
        // 节
        if(jieBegTime[1] == today[1] && jieBegTime[2] == today[2]) {
            jie = baziData.jieqi.beg.name;
        }else if(jieEndTime[1] == today[1] && jieEndTime[2] == today[2]) {
            jie = baziData.jieqi.end.name;
        }
        resultData['jie'] = jie;

        // 阴历日期
        var lunarTime = PAIPAN.Solar2Lunar(today[0], today[1], today[2]),
            lunarDay = FORMAT.getChineseWordByNumber('month', lunarTime.m) + FORMAT.getChineseWordByNumber('day', lunarTime.d);
        resultData['lunar'] = {y: baziData.bazi.slice(0, 2), m: baziData.bazi.slice(2, 4), rg: FORMAT.getTianGanWordDataByIndex(baziData.tg[2]), rz: FORMAT.getDiZhiWordDataByIndex(baziData.dz[2]), date: lunarDay}

        console.log('getTodayCalendarInfoData', baziData, resultData, jieBegTime, jieEndTime);
        return resultData;
    }
    
}

export {
    COLLATE_DATA_MANAGER
}